import styled from 'styled-components/native';

export default styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  padding: 3px 7px;
  background: #e9e8ff;
  border-radius: 6px;
`;
